import axios from "@/libs/api.request";
export function getBookListNoContent(params) {
    return axios.request({
        url: "WebHandbook/getBookListNoContent",
        method: "get",
        params:params,
    })
}

export function getBookList(params) {
    return axios.request({
        url: "WebHandbook/getBookList",
        method: "get",
        params:params,
    })
}


export function submitBookHand(params) {
    return axios.request({
        url: "WebHandbook/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
// 删除
export function delBookHand(id) {
    return axios.request({
        url: "WebHandbook/Delete",
        method: "post",
        params:{id:id}
    })
}

//获取产品说明书信息
export function getBookProNum(params) {
    return axios.request({
        url: "WebHandbook/getBookProNum",
        method: "get",
        params:params,
    })
}

//说明书与产品关联
export function getBookProDataList(params) {
    return axios.request({
        url: "HandbookProduct/getBookProDataList",
        method: "get",
        params:params,
    })
}
//获取产品信息
export function getProductBookList(params) {
    return axios.request({
        url: "HandbookProduct/getProductBookList",
        method: "get",
        params:params,
    })
}
// 添加/修改 说明书与产品关联
export function addProductBook(params) {
    return axios.request({
        url: "HandbookProduct/CreateUpdate",
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}